
import { apiFetch } from './client';
import type { KeyStatus, SetKeyPayload, ProviderUpsert, ProvidersResponse } from '../types/contracts';

export const settingsApi = {
  getKeyStatus: ()                      => apiFetch<KeyStatus[]>('/api/settings/keys'),
  setKey:       (p: SetKeyPayload)      => apiFetch<void>('/api/settings/keys',  { method: 'PUT',    body: JSON.stringify(p) }),
  deleteKey:    (provider: string)      => apiFetch<void>(`/api/settings/keys/${provider}`, { method: 'DELETE' }),
  getSettings:  ()                      => apiFetch<{ model_config: any; keys: KeyStatus[] }>('/api/settings'),
  saveSettings: (p: { provider: string; baseUrl?: string; models: { brain: string; mid: string; cheap: string } }) =>
    apiFetch<void>('/api/settings', { method: 'PUT', body: JSON.stringify(p) }),
  listProviders: ()                     => apiFetch<ProvidersResponse>('/api/settings/providers'),
  upsertProvider: (p: ProviderUpsert)   => apiFetch<{ success: boolean; id: string }>('/api/settings/providers', { method: 'POST', body: JSON.stringify(p) }),
  deleteProvider: (id: string)          => apiFetch<{ deleted: boolean; id: string }>(`/api/settings/providers/${id}`, { method: 'DELETE' }),
  setDefaultProvider: (id: string)      => apiFetch<{ success: boolean; default_provider: string }>('/api/settings/providers/default', { method: 'PUT', body: JSON.stringify({ id }) }),
  setEnvLabel: (label: string)        => apiFetch<{ success: boolean; label: string }>('/api/settings/providers/env-label', { method: 'PATCH', body: JSON.stringify({ label }) }),
  fetchModels:  (p: { baseUrl?: string; key?: string; providerId?: string; type?: string }) =>
    apiFetch<{ models: string[] }>('/api/settings/models', { method: 'POST', body: JSON.stringify(p) }),
  // Sprint 3: UX-настройки промежуточных статусов.
  getProfile:  ()                       => apiFetch<ProfileSettings>('/api/settings/profile'),
  saveProfile: (p: Partial<ProfileSettings>) => apiFetch<ProfileSettings>('/api/settings/profile', { method: 'PUT', body: JSON.stringify(p) }),
  getUsage: () => apiFetch<{ plan: string; total_tokens_used: number; token_limit: number | null; billing_period_started_at: string | null }>('/api/settings/usage'),
};

export interface ProfileSettings {
  verbose_status: boolean;
  verbose_for_scheduled: boolean;
}
